<!--动态图对象 右键属性-->
<template>
  <div>
    <gs-modal
      v-loading="loading"
      v-model="visible"
      :before-close="beforeClose"
      :before-confirm="beforeConfirm"
      :title="isEdit?name+'-图形化界面':'新建'+'-图形化界面'"
      :has-form="true"
      class="my-test-class"
      width="50%"
      top="10%"
      @close="close"
      @confirm="handleConfirm"
    >
      <div>
        <a
          class="gs-modal-close"
          style="left: 90%; top: 13px"
          @click="dialogHelp = true"
        >
          <i
            class="el-icon-question"
            style="font-size: 17px;color: #737373"
          ></i>
        </a>
      </div>
      <gs-tabs
        v-model="activeName"
        type="content-tab"
      >
        <gs-tab-pane
          label="常规"
          name="first"
        >
          <gs-form
            label-width="95px"
            label-position="left"
            gap="small"
          >
            <gs-form-item
              label="名称"
              prop="target"
              class="form-item-radio"
            >
              <gs-input
                ref="nameInput"
                v-model="name"
              />
            </gs-form-item>
            <gs-form-item
              label="描述"
              prop="target"
              class="form-item-radio"
            >
              <gs-input v-model="description" />
            </gs-form-item>
            <gs-form-item
              label="选择模板"
              prop="target"
              class="form-item-radio"
            >
              <!--<gs-radio-group style="margin-left: 3%" v-for="(item, index) in tableDatas" :key="index"  v-model="radio">
        <gs-radio :label="index">{{item.modelName}}</gs-radio>
      </gs-radio-group>-->
              <div
                v-for="(item,index) in tableDatas"
                :key="index"
                class="demo-image__preview"
                style="margin-left: 2%"
              >
                <el-image
                  style="width: 100px; height: 100px"
                  :src="item.imgPath"
                >
                </el-image>
                <div style="margin-left: 6%">
                  <el-radio
                    style="margin-left: 2%"
                    v-model="radios"
                    :label="item.modelId"
                  >{{item.modelName}}</el-radio>
                </div>
              </div>
            </gs-form-item>
          </gs-form>
        </gs-tab-pane>
        <gs-tab-pane
          label="上传"
          name="list"
        >
          <div>
            <input
              id="uploadFile"
              type="file"
              ref="filed"
            />
            <el-button
              slot="trigger"
              size="small"
              type="primary"
              @click="getFile"
            >提交</el-button>
            <a
              href="#"
              class="a_post"
              @click="downDocument"
            >发起POST请求</a>
            <!--<el-upload class="upload-demo" ref="upload" action="#" :on-change="fileChange"  :auto-upload="false"   :limit="5">
               <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
            </el-upload>-->
            <!--<el-upload class="upload-demo" ref="upload" action="#" :on-change="fileChange"  :auto-upload="false" accept=".txt"  :limit="5">
               <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
            </el-upload>-->
            <!--<el-button  size="small" type="primary" style="background-color: white;color: #2b2b2b;border: 1px solid silver;margin-left: 42%;margin-top: 5%" @click="upload">提交</el-button>-->
          </div>
        </gs-tab-pane>
        <!-- <gs-tab-pane
        label="模板管理"
        name="second"
      >
        <el-row style="margin-top: 1%;margin-left: 1%">
          <el-col :span="4" style="">
            <el-input
              placeholder="请输入模板名称"
              v-model="link"
              size="small"
              clearable>
            </el-input>
          </el-col>
          <el-col :span="4" style="margin-left: 1%"><el-button @click="links" type="info" icon="el-icon-search" size="small" circle></el-button></i>
          </el-col>
        </el-row>
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          border
          style="width: 98%;margin-top: 1%;margin-left: 1%"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            align="center"
            width="55">
          </el-table-column>
          <el-table-column
            label="模板名称"
            prop="modelName"
            align="center"
            width="120">
          </el-table-column>
          &lt;!&ndash;<el-table-column
            prop="modelNum"
            label="模板类型"
            align="center"
            width="120">
          </el-table-column>&ndash;&gt;
          <el-table-column prop="imgPath" label="模板图" width="150" align="center">
            &lt;!&ndash; 图片的显示 &ndash;&gt;
            <template   slot-scope="scope">
              <img  :src="scope.row.imgPath"  min-width="70" height="70" />
            </template>
          </el-table-column>
          <el-table-column
            prop="modelDesc"
            align="center"
            label="模板描述"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="操作" align="center" min-width="80">
            　　　　<template slot-scope="scope">
                        <el-button type="success" size="mini" @click="lookUp(scope.row)" plain>查看</el-button>
            　　　　　　<el-button type="primary" size="mini" @click="modifyUser(scope.row)" plain>修改</el-button>
            　　　　　　<el-button type="danger"  size="mini"  @click="deleteUser(scope.row.modelId)" plain>删除</el-button>
            　　　　</template>
            　　</el-table-column>
        </el-table>
        &lt;!&ndash; 删除提示框 &ndash;&gt;
        <el-dialog title="提示" :visible.sync="delVisible" width="300px" center>
          <div class="del-dialog-cnt">删除不可恢复，是否确定删除？</div>
          <span slot="footer" class="dialog-footer">
                <el-button @click="delVisible = false">取 消</el-button>
                <el-button type="primary" @click="deleteRow" >确 定</el-button>
            </span>
        </el-dialog>
        <div class="bottom-btn">
          <gs-button @click="add">添加</gs-button>
          <gs-button @click="del">批量删除</gs-button>
        </div>
      </gs-tab-pane>-->
      </gs-tabs>
    </gs-modal>

    <gs-modal
      title="帮助"
      v-model="dialogHelp"
      class="my-test-class"
      width="50%"
      :before-close="handleCloseHelp"
    >
      <span class="tab">常规</span><br>
      <hr />
      <span class="tit">名称：</span><span class="txt">趋势日志对象的名称</span><br>
      <span class="tit">描述：</span><span class="txt">该对的详细描述</span><br>
      <span class="tit">选择模板：</span><span class="txt">选择新建那个图形化界面的模板</span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <!--<el-button @click="dialogHelp = false">取 消</el-button>
      <el-button type="primary" @click="dialogHelp = false">确 定</el-button>-->
      </span>
    </gs-modal>
    <!--<gs-modal
      v-model="visibleAddRun"
      :before-close="beforeCloseAddRun"
      class="my-test-class"
      :title="title"
      @confirm="handleConfirmAddRun"
      width="40%"
    >
      <gs-tabs
        v-model="activeNameRun"
        type="content-tab"
      >
        <gs-tab-pane
          label="添加模板"
          name="first"
        >
          <gs-form
            label-width="95px"
            label-position="left"
            gap="small"
          >
            <gs-form-item
              label="名称"
              prop="target"
              class="form-item-radio"
            >
              <gs-input
                ref="nameInput"
                v-model="nameRun"
              />
            </gs-form-item>
            <gs-form-item
              label="描述"
              prop="target"
              class="form-item-radio"
            >
              <gs-input v-model="descriptionRun" />
            </gs-form-item>
              <gs-form-item
              label="模板选择"
              prop="target"
              class="form-item-radio"
            >
              &lt;!&ndash;<div class="demo-image__preview" style="margin-left: 2%">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="modelOne"
                  :preview-src-list="srcList">
                </el-image>
                <div style="margin-left: 2%">
                  <el-radio  v-model="radios" label="电机组">电机组</el-radio>
                </div>
              </div>
              <div class="demo-image__preview" style="margin-left: 2%">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="modelTwo"
                  :preview-src-list="srcListTwo">
                </el-image>
                <div style="margin-left: 2%">
                  <el-radio  v-model="radios" label="电机类型">电机类型</el-radio>
                </div>
              </div>&ndash;&gt;
              <div v-for="(item,index) in imgList" :key="index" class="demo-image__preview" style="margin-left: 2%">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="item.imgPath"
                >
                </el-image>
                <div style="margin-left: 6%">
                  <el-radio style="margin-left: 2%" v-model="radiosRun" :label="item.imgPath">{{item.imgName}}</el-radio>
                </div>
              </div>
              &lt;!&ndash;  <div class="demo-image__preview" style="margin-left: 2%">
                  <el-image
                    style="width: 100px; height: 100px"
                    src="http://192.168.2.108:9001/15747406813731574740477884.jpg"
                    :preview-src-list="srcList">
                  </el-image>
                  <div style="margin-left: 2%">
                    <el-radio  v-model="radios" label="电机组">电机组</el-radio>
                  </div>
                </div>&ndash;&gt;
            </gs-form-item>
            &lt;!&ndash;<gs-form-item
              label="上传模板"
              prop="target"
              class="form-item-radio"
            >
              <gs-button
                @click="checkDevice"
              >点击上传</gs-button>
            </gs-form-item>&ndash;&gt;
          </gs-form>
        </gs-tab-pane>
        <gs-tab-pane
          label="图形管理"
          name="second">
          <gs-form
            label-width="95px"
            label-position="left"
            gap="small"
          >
            <gs-form-item
              label="上传点位"
              prop="target"
              class="form-item-radio"
            >
              <el-upload class="upload-demo" ref="upload" action="#" :on-change="fileChange"  :auto-upload="false" accept=".txt"  :limit="5">
                 <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
              </el-upload>
              &lt;!&ndash; x:<gs-input
                  ref="nameInput"
                  v-model="form.xdata"
                  style="width: 20%;margin-left: 1%"
                /> %&ndash;&gt;
              &nbsp;&nbsp;&nbsp;&nbsp;
              &lt;!&ndash;  y:<gs-input
                  ref="nameInput"
                  v-model="form.ydata"
                  style="width: 20%;margin-left: 1%"
                /> %&ndash;&gt;
              &lt;!&ndash;<el-button icon="el-icon-plus" @click="addItem"  size="mini" circle></el-button>&ndash;&gt;
            </gs-form-item>
            &lt;!&ndash;<div v-for="(item, index) in form.dynamicItem" :key="index">
              <gs-form-item
                label=""
                prop="target"
                class="form-item-radio"
              >
                x:<gs-input
                ref="nameInput"
                v-model="item.xdata"
                style="width: 20%;margin-left: 1%"
              /> %
                &nbsp;&nbsp;&nbsp;&nbsp;
                y:<gs-input
                ref="nameInput"
                v-model="item.ydata"
                style="width: 20%;margin-left: 1%"
              /> %
                <i class="el-icon-delete" @click="deleteItem(item, index)"></i>
              </gs-form-item>

            </div>&ndash;&gt;
            <gs-form-item
              label="上传图形模板"
              prop="target"
              class="form-item-radio"
            >
              <div>
                <el-upload class="upload-demo" action="auto" :http-request="uploadSectionFile" list-type="picture">
                  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2MB</div>
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
                <el-button  size="small" type="primary" style="background-color: white;color: #2b2b2b;border: 1px solid silver;margin-left: 42%;margin-top: 5%" @click="upload">提交</el-button>
              </div>
              &lt;!&ndash; <div>
                 <input type="file"  value="点击"  id="img" >
                 <button class="myBtn"  @click="Uploadjq">
                   上传文件
                 </button>
               </div>&ndash;&gt;
            </gs-form-item>

            <el-table
              ref="multipleTable"
              :data="imgList"
              tooltip-effect="dark"
              border
              style="width: 98%;margin-top: 1%;margin-left: 1%"
              :header-cell-style="{background:'#eef1f6',color:'#606266'}"
              @selection-change="handleSelectionChange">
              <el-table-column
                type="selection"
                align="center"
                width="55">
              </el-table-column>
              <el-table-column
                label="图片名称"
                prop="imgName"
                align="center"
                width="120">
              </el-table-column>
              &lt;!&ndash;<el-table-column
                prop="modelNum"
                label="模板类型"
                align="center"
                width="120">
              </el-table-column>&ndash;&gt;
              <el-table-column prop="imgPath" label="模板图" width="150" align="center">
                &lt;!&ndash; 图片的显示 &ndash;&gt;
                <template   slot-scope="scope">
                  <img  :src="scope.row.imgPath"  min-width="70" height="70" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" min-width="80">
                　　　　<template slot-scope="scope">
                　　　　　　<el-button type="danger"  size="mini"  @click="deleteImg(scope.row)" plain>删除</el-button>
                　　　　</template>
                　　</el-table-column>
            </el-table>
          </gs-form>
        </gs-tab-pane>
        </gs-tab-pane>
      </gs-tabs>
    </gs-modal>-->
    <!--<gs-modal
      v-model="visibleAdd"
      :before-close="beforeCloseAdd"
      class="my-test-class"
      title="添加模板"
      @close="closeAdd"
      @confirm="handleConfirmAdd"
      width="40%"
    >
      <gs-form
        label-width="95px"
        label-position="left"
        gap="small"
      >
        <gs-form-item
          label="名称"
          prop="target"
          class="form-item-radio"
        >
          <gs-input
            ref="nameInput"
            v-model="name"
          />
        </gs-form-item>
        <gs-form-item
          label="描述"
          prop="target"
          class="form-item-radio"
        >
          <gs-input v-model="description" />
        </gs-form-item>
        <gs-form-item
          label="模板选择"
          prop="target"
          class="form-item-radio"
        >
          <div class="demo-image__preview">
            <el-image
              style="width: 100px; height: 100px"
              :src="url"
              :preview-src-list="srcList">
            </el-image>
            <div style="margin-left: 2%">
              <el-radio style="margin-left: 12%" v-model="radios" label="1">模板1</el-radio>
            </div>
          </div>
          <div class="demo-image__preview" style="margin-left: 2%">
            <el-image
              style="width: 100px; height: 100px"
              :src="url"
              :preview-src-list="srcList">
            </el-image>
            <div style="margin-left: 6%">
              <el-radio style="margin-left: 16%"  v-model="radios" label="2">模板2</el-radio>
            </div>
          </div>
        </gs-form-item>
      </gs-form>
    </gs-modal>-->
    <!--<gs-modal
      v-model="visibleProperties"
      :before-close="beforeCloseProperties"
      class="my-test-class"
      title="模板详情"
      @close="closeProperties"
      @confirm="handleConfirmProperties"
    >
      <gs-form
        label-width="95px"
        label-position="left"
        gap="small"
      >
        <gs-form-item
          label="模板名称:"
          prop="target"
          class="form-item-radio"
        >
          <span>{{model.modelName}}</span>
        </gs-form-item>
        <gs-form-item
          label="模板描述:"
          prop="target"
          class="form-item-radio"
        >
          <span>{{model.modelDesc}}</span>
        </gs-form-item>
        <gs-form-item
          label="模板图片:"
          prop="target"
          class="form-item-radio"
        >
          <img  :src="modelImgPath"  min-width="70" height="70" />
        </gs-form-item>
        <gs-form-item
          label="模板信息:"
          prop="target"
          class="form-item-radio"
        >
          <span>{{model.fileStr}}</span>
        </gs-form-item>
      </gs-form>
    </gs-modal>-->
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
import eventBus from '../timeChart/vue.js'
export default {
  components: {

  },
  data() {
    return {
      dialogHelp: false,
      modelImgPath: '',
      model: {
        modelName: '',
        modelDesc: '',
        fileStr: ''
      },
      //模板管理
      link: '',
      imgList: [],
      tableData: [],
      activeNameRun: 'first',
      uploadFile: '',
      posterUrl: '',
      imgUrls: [],
      imgWidth: '320',
      imgHeight: '400',
      // imgAdd:false,
      delVisible: false,
      modelUpdate: false,
      modelId: '',
      title: '添加模板',
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      nameRun: '',
      descriptionRun: '',
      visibleAddRun: false,
      radiosRun: '电机组',
      multipleSelection: [],
      contentHtml: '',
      //创建模板
      tableDatas: [
        { imgPath: '../../static/img/108.png', modelName: '腾讯大厦', modelId: 116 },
        { imgPath: '../../static/img/100.png', modelName: '冷冻站', modelId: 100 },
        { imgPath: '../../static/img/会议室.png', modelName: '会议室', modelId: 103 },
        { imgPath: '../../static/img/会议室.png', modelName: '北京会议室', modelId: 106 },
        { imgPath: '../../static/img/107.png', modelName: '厂房图形', modelId: 107 },
        { imgPath: '../../static/img/108.png', modelName: '兰生大厦', modelId: 108 },
        //{ imgPath: '../../static/img/水泵房.png', modelName: '机柜视图', modelId: 109 },
        { imgPath: '../../static/img/水泵房.png', modelName: '机柜视图', modelId: 117 },
        { imgPath: '../../static/img/108.png', modelName: '东浩大厦', modelId: 110 },
        { imgPath: '../../static/img/107.png', modelName: '机房视图', modelId: 111 },
        { imgPath: '../../static/img/100.png', modelName: '新冷冻站', modelId: 112 },
        { imgPath: '../../static/img/会议室.png', modelName: '会议室(外)', modelId: 113 },
        { imgPath: '../../static/img/107.png', modelName: 'suHome', modelId: 115 },
        { imgPath: '../../static/img/会议室.png', modelName: '北京办公室', modelId: 118 },
        { imgPath: '../../static/img/107.png', modelName: '光明渔业', modelId: 119 },
      ],
      radios: '',
      url: '/static/img/graphicShow.jpg',
      srcList: [
        '/static/img/graphicShow.jpg',
      ],
      radio: 1,
      objectInfo: {},
      loading: false,
      activeName: 'first',
      form: {
        objectSeries: [],
        primaryY_autoScale: true,
        primaryY_Mininum: 0,
        primaryY_maximum: 100,
        secondaryY_autoScale: true,
        secondaryY_Mininum: 0,
        secondaryY_maximum: 100,
        logInterval_value: 1,
        logInterval_unit: 's',
        maxLogNum: ''
      },
      description: '',
      checked: '',
      options: [
        {
          label: '秒(s)',
          value: 's'
        }, {
          label: '分(m)',
          value: 'm'
        }, {
          label: '时(h)',
          value: 'h'
        }, {
          label: '天(d)',
          value: 'd'
        }
      ],
      visibleAdd: false,
      visibleProperties: false,
      addList: [],
      props: {
        label: 'name',
        disabled: 'type:folder'
      },
      selectList: [],
      name: '',
      showList: [],
      row: '',
      isEdit: false,
      oldData: {},
      // 上传文件
      uploadUrl: '',
    }
  },
  computed: {
    ...mapState({
      visible: 'graphiCallyShow',
      nodeData: 'objectInfo'
    })
  },
  watch: {
    tableData() {
      this.form.objList = this.tableData
    },
    nodeData() {

    },
    visible() {
      let _this = this
      /*service.listModel().then(res => {
        _this.$nextTick(() => {
         /!* _this.tableDatas = res*!/
          console.info(res)
        })
      }).catch(err => {
        this.$Message.error(err.message)
      })*/
      /*service.listModel().then(res => {
        _this.tableData = res
      }).catch(err => {
        this.$Message.error(err.message)
      })*/
      if (this.visible) {
        this.objectInfo = JSON.parse(JSON.stringify(this.nodeData))
        setTimeout(() => {
          // this.$refs.nameInput.focus()
        }, 100)
        if (JSON.stringify(this.objectInfo) !== '{}' && this.objectInfo.type === 'graphic') {
          this.isEdit = true
          this.activeName = 'first'
          this.form = this.objectInfo.attribute ? this.objectInfo.attribute : {}
          this.description = this.objectInfo.description ? this.objectInfo.description : ''
          this.name = this.objectInfo.name ? this.objectInfo.name : ''
          this.form.objectSeries = this.objectInfo.attribute.objectSeries ? JSON.parse(JSON.stringify(this.objectInfo.attribute.objectSeries)) : []
        } else {
          this.isEdit = false
          this.activeName = 'first'
          this.form = {
            objectSeries: [],
            primaryY_autoScale: true,
            primaryY_Mininum: 0,
            primaryY_maximum: 100,
            secondaryY_autoScale: true,
            secondaryY_Mininum: 0,
            secondaryY_maximum: 100,
            logInterval_value: 1,
            logInterval_unit: 's',
            maxLogNum: ''
          }
          this.description = ''
          this.name = ''
        }
      }
    }
  },
  created() {

  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapMutations({
      close: 'GRAPHI_CALLY_HIDE',
      needReload: 'NEED_RELOAD_TREE'
    }),
    deleteImg(row) {
      let _this = this
      service.delImg(row.imgName, row.imgId).then(res => {
        service.getImgAll().then(resImg => {
          _this.imgList = resImg
        }).catch(err => {
          console.log(err)
        })
        this.$Message.success("删除成功")
      }).catch(err => {
        console.log(err)
      })
    },
    beforeClose() {
      this.close()
    },
    // cancel () {
    //   this.nodeData = this.oldData
    //   this.close()
    // },
    getBase64Image(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.width, img.height);
      var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
      var dataURL = canvas.toDataURL("image/" + ext);
      return dataURL;
    },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      if (!this.form.primaryY_autoScale) {
        if (this.form.primaryY_Mininum >= this.form.primaryY_maximum) {
          this.$Message.warning('Y轴最小值必须小于最大值')
          return
        }
      }
      if (!this.form.secondaryY_autoScale) {
        if (this.form.secondaryY_Mininum >= this.form.secondaryY_maximum) {
          this.$Message.warning('Y轴最小值必须小于最大值')
          return
        }
      }
      // done(false)可以阻止modal关闭
      done()
    },
    handleConfirm() {
      let _this = this
      this.loading = true
      let arr = []
      let backArr = JSON.parse(JSON.stringify(this.form.objectSeries))
      this.form.objectSeries.forEach(e => {
        arr.push(e.id)
      })
      this.form.objectSeries = arr
      if (this.objectInfo.id && this.objectInfo.type === 'graphic') {
        let param = {
          id: this.objectInfo.id,
          'name': this.name,
          'type': this.objectInfo.type,
          value: this.objectInfo.value,
          'parentId': this.objectInfo.parentId,
          'description': this.description,
          'attribute': this.form  // 其他信息这里，键值对形式
        }
        service.renamePoint(param).then(res => {
          this.loading = false
          this.$Message.success('修改成功')
          _this.objectInfo.attribute.objectSeries = backArr
          this.close()
          this.objectInfo.name = this.name
          res.attribute.objectSeries = backArr
          this.$store.state.tabPanel = res
          this.$store.state.updateTreeNode = res
          this.description = ''
          this.name = ''
          // this.form = {
          //   objectSeries: []
          // }
          this.showList = []
          // eventBus.$emit('changeInterval', res)
        }).catch(err => {
          this.loading = false
          this.form.objectSeries = backArr
          this.$Message.error(err.message)
        })
      } else {
        let param = {
          'name': this.name,
          'parentId': this.objectInfo.id,
          "type": "graphic",
          'description': this.description,
          "attribute": {
            'modelId': this.radios,
          }
        }
        service.newAddPoint(param).then(res => {
          this.loading = false
          this.$Message.success('添加成功')
          setTimeout(() => {
            res.attribute.objectSeries = backArr
            _this.$store.state.addTreeNode = res
          }, 0)
          this.close()
          this.description = ''
          this.name = ''
          // this.form = {
          //   objectSeries: []
          // }
          this.showList = []
        }).catch(err => {
          this.loading = false
          this.form.objectSeries = backArr
          this.$Message.error(err.message)
        })
      }
    },
    /*onChange (v) {

    },*/
    add() {
      this.title = '添加模板'
      let _this = this
      this.visibleAddRun = true

      /*service.getTree('Point').then(res => {
        console.log(res)
        this.addList = res
        if (_this.form.objectSeries !== null && _this.form.objectSeries.length > 0) {
          setTimeout(() => {
            _this.form.objectSeries.forEach(res => {
              _this.$refs.tree.setChecked(res.id, true)
            })
          }, 0)
        }
      })*/
    },
    del() {
      if (this.selectList === null || this.selectList.length === 0) {
        this.$Message.warning('请至少选择一项')
        return
      }
      this.selectList.forEach((value, index, array) => {
        this.form.objectSeries = this.form.objectSeries.filter(e => {
          return e.id !== value.id
        })
      })
    },
    /*yAxis () {

    },*/
    property() {
      if (this.selectList.length !== 1) {
        this.$Message.warning('只能勾选一项')
        return
      }
      this.visibleProperties = true
    },
    beforeCloseAdd() {
      this.visibleAdd = false
    },
    closeAdd() {
      this.visibleAdd = false
    },
    handleConfirmAdd() {
      if (this.name === '' || this.description === '') {
        this.$Message.warning('名称描述不能为空!')
      } else {
        var img = '/static/img/graphicShow.jpg';//imgurl 就是你的图片路径
        var image = new Image();
        image.src = img;
        image.onload = function () {
          var base64 = this.getBase64Image(image);
          alert(base64);
        }
      }
      /*let _this = this
      this.$refs.tree.getCheckedNodes(true).forEach(e => {
        _this.form.objectSeries.push(e.data)
      })
      this.form.objectSeries = this.unique(this.form.objectSeries, 'id')
      this.visibleAdd = false*/
    },
    unique(arr, name) {
      var hash = {}
      return arr.reduce(function (item, next) {
        hash[next[name]] ? '' : hash[next[name]] = true && item.push(next)
        return item
      }, [])
    },
    beforeCloseProperties() {
      this.visibleProperties = false
    },
    closeProperties() {
      this.visibleProperties = false
    },
    handleConfirmProperties() {
      this.visibleProperties = false
    },
    checkEvent(node, isSelect, halfSelect) {
      console.log(node)
      console.log(isSelect)
      console.log(halfSelect)
      //   value_Analog,
      // value_Multistate,
      // value_Binary,
      // value_String,
      // BinaryInput,
      // BinaryOutput,
      // AnalogInput,
      // AnalogOutput
      switch (node.type) {
        case 'value_Analog':

          break
        case 'value_Multistate':

          break
        case 'value_Binary':

          break
        case 'value_String':

          break
        case 'BinaryInput':

          break
        case 'BinaryOutput':

          break
        case 'AnalogInput':

          break
        case 'AnalogOutput':
          break

        default:
          this.$Message.error('此节点为目录，无法被选择')
          this.$refs.tree.setChecked(node.id, false)
          break
      }
    },
    selectData(selection, row) {
      this.selectList = selection
    },
    //创建模板
    getData() {
      let _this = this;
      /*service.listModel().then(res => {
        _this.tableData = res
      }).catch(err => {
        this.$Message.error(err.message)
      })*/
    },
    fileChange(file, fileList) {
      var that = this;
      var isLtM = file.size / 1024 / 1024 < 5;//文件大小不能大于5m
      if (!isLtM) {
        this.$message({
          message: '上传文件大小不能超过 5MB!',
          type: 'warning'
        });
        if (!isLtM) {
          for (var i = 0; i < fileList.length; i++) {
            if (file == fileList[i]) {
              fileList.splice(i, 1);   //大于5m上传列表不显示，当前函数无返回值所以无法控制
            }
          }
        }
      } else {
        that.format(file, fileList);  //做校验函数
      }
    },
    format(file, fileList) {
      var that = this;
      if (file.raw) {
        let reader = new FileReader();//读取文件内容
        reader.readAsText(file.raw, 'gb2312'); //防止中文乱码问题，不加reader.onload方法都不会触发
        reader.onload = function (e) {
          that.contentHtml = e.target.result;//txt文本内容，接下来就可以对其进行校验处理了    
        }

      }
    },
    uploadSectionFile(param) {
      let fileObj = param.file;
      const isLt2M = fileObj.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$Message.error("上传文件大小不能超过 2MB!");
        return;
      }
      if (fileObj.type === "image/jpeg") {
        this.uploadFile = new File([fileObj], new Date().getTime() + ".jpg", {
          type: "image/jpeg"
        });
      } else if (fileObj.type === "image/png") {
        this.uploadFile = new File([fileObj], new Date().getTime() + ".png", {
          type: "image/png"
        });
      } /*else if (fileObj.type === "application/pdf"){
          this.uploadFile = new File([fileObj], new Date().getTime() + ".pdf", {
            type: "application/pdf"
          });
        }*/
      else {
        this.$Message.error("只能上传jpg/png文件");
        return;
      }
    },
    upload(file) {
      let _this = this
      let param = new FormData(); // FormData 对象
      param.append("file", this.uploadFile); // 文件对象
      param.append("name", 'zypzyp'); // 其他参数
      param.append("fileStr", _this.contentHtml);
      param.append('parentId', this.objectInfo.id,)
      param.append('type', 'files',)
      service.formUpload(param).then(res => {
        console.info(res)
        this.$Message.success("上传成功")
        service.getImgAll().then(res => {
          _this.imgList = res
          console.info(res)
        }).catch(err => {
          console.log(err);
        })
      }).catch(err => {
        console.log(err);
        this.$Message.error("上传失败")
      })
      /* this.$axios({
         method: "post",
         url: "/GradeSystem/upload.do",
         data: param
       })
         .then(response => {
           this.$message({
             message: '上传成功',
             type: 'success'
           });
         })
         .catch(error => {
           this.$message.error("上传失败,请稍后重试");
         });*/
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //删除模板
    deleteUser(val) {
      this.delVisible = true
      this.modelId = val
    },
    //link模糊查询
    links() {
      let _this = this
      service.dimLink(_this.link).then(res => {
        _this.tableData = res
      }).catch(err => {
        console.log(err)
      })
    },
    //确定删除
    deleteRow() {
      this.delVisible = false
      let _this = this
      service.delModel(this.modelId).then(res => {
        if (res === 0) {
          this.$Message.success('删除成功');
          service.listModel().then(res => {
            _this.tableData = res
          }).catch(err => {
            this.$Message.error(err.message)
          })
        }
      }).catch(err => {
        this.$Message.error(err.message)
      })
    },
    //修改模板
    modifyUser(val) {
      this.modelUpdate = true
      this.title = '修改模板'
      this.nameRun = val.modelName
      this.descriptionRun = val.modelDesc
      this.radiosRun = val.modelNum
      this.visibleAddRun = true;
      this.modelId = val.modelId
    },
    lookUp(val) {
      this.model.modelName = val.modelName
      this.model.modelDesc = val.modelDesc
      this.model.fileStr = val.fileStr
      this.modelImgPath = val.imgPath
      this.visibleProperties = true
    },
    //关闭弹窗
    beforeCloseAddRun() {
      this.visibleAddRun = false
    },
    /* beforeCloseImgAdd () {
       this.imgAdd = false
     },*/
    //确定按钮
    handleConfirmAddRun() {
      if (this.nameRun === '' || this.descriptionRun === '') {
        this.$Message.warning('名称描述不能为空!')
      } else {
        /*let _this = this
        let img = '/static/img/101.png';
        let image = new Image();
        let base64 = '';
        image.src = img;
        image.onload = function(){
          base64 = _this.$options.methods.getBase64Image(image);
          console.info(base64)
        }*/
        let _this = this
        if (this.modelUpdate) {  // 修改模板
          let obj = {
            modelName: this.nameRun,
            modelDesc: this.descriptionRun,
            modelNum: this.radiosRun,
            modelId: this.modelId
          }
          service.updataModel(obj).then(res => {
            if (res === 0) {
              this.$Message.success('修改成功');
              _this.visibleAddRun = false
              service.listModel().then(res => {
                _this.tableData = res
              }).catch(err => {
                this.$Message.error(err.message)
              })
            }
          }).catch(err => {
            this.$Message.error(err.message)
          })
          this.modelUpdate = false
        } else {
          let obj = {
            //modelId:this.radios,
            imgPath: this.radiosRun,
            modelName: this.nameRun,
            modelDesc: this.descriptionRun,
            modelNum: this.radiosRun
          }
          service.addModel(obj).then(res => {
            if (res === 0) {
              this.$Message.success('添加成功');
              _this.visibleAddRun = false
              service.listModel().then(res => {
                _this.tableData = res
              }).catch(err => {
                this.$Message.error(err.message)
              })
            }
          }).catch(err => {
            this.$Message.error(err.message)
          })
        }
      }

    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 上传功能
    getFile() {
      let _this = this
      console.log(this.$refs.filed.files)
      this.uploadFile = this.$refs.filed.files[0]
      let param = new FormData(); // FormData 对象
      param.append("file", this.uploadFile); // 文件对象
      param.append("name", 'zypzyp'); // 其他参数
      param.append('parentId', this.objectInfo.id,)
      param.append('type', 'files',)
      service.formUpload(param).then(res => {
        console.info(res)
        this.$Message.success("上传成功")
        document.getElementById("uploadFile").value = null;
      }).catch(err => {
        console.log(err);
        document.getElementById("uploadFile").value = null;
        this.$Message.error("上传失败")
      })
    },
    // 下载功能
    downDocument() {
      /*$(".a_post").on("click",function(event){
        event.preventDefault();//使a自带的方法失效，即无法调整到href中的URL
        var url='http://192.168.10.95:9001/manage-object/project/view?id=';   //请求的URl
        var xhr = new XMLHttpRequest();		//定义http请求对象
        xhr.open("POST", url, true);
        xhr.setRequestHeader("Content-type","application/x-www-form-urlencoded");
        xhr.setRequestHeader("Authorization",token);
        xhr.send();
        xhr.responseType = "blob";  // 返回类型blob
        xhr.onload = function() {
          if (this.status===200) {
            var blob = this.response;
            console.log(xhr.getResponseHeader("content-disposition"))
            let temp = xhr.getResponseHeader("content-disposition").split(";")[1].split("filename=")[1];
            var fileName = decodeURIComponent(temp);
            var reader = new FileReader();
            reader.readAsDataURL(blob);  // 转换为base64，可以直接放入a标签href
            reader.onload = function (e) {
              console.log(e);
              var a = document.createElement('a');
              a.download = fileName + ".xlsx";
              a.href = e.target.result;
              $("body").append(a);    // 修复firefox中无法触发click
              a.click();
            }
          else
            {
              alert("出现了未知的错误!");
            }
            }
            }
        })*/
    },
    handleCloseHelp() {
      this.dialogHelp = false
    }
  }
}
</script>
<style scoped>
.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box; /* Firefox */
  -webkit-box-sizing: border-box; /* Safari */
  width: 47%;
  float: left;
  margin-right: 13px;
}
fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}
.bottom-btn {
  margin: 20px;
  text-align: center;
}
.form-item-objectSeries {
  height: 200px;
  overflow: auto;
  margin-bottom: 12px;
  padding: 12px;
  border: solid 1px #d9d9d9;
  border-radius: 1px;
}
.demo-image__preview {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/graphically/graphically.vue